export const REQUEST_FETCH_GOALS = "request_fetch_goals"
export const FETCH_GOALS_SUCCESS = "fetch_goals_success"
export const FETCH_GOALS_FAILURE = "fetch_goals_failure"
export const GOAL_ACTION_CHANGES = "goal_action_changes"

export const CLEAR_FETCH_GOALS = "clear_fetch_goals"